var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiversityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.5C5.10457 16.5 6 15.6046 6 14.5C6 13.3954 5.10457 12.5 4 12.5C2.89543 12.5 2 13.3954 2 14.5C2 15.6046 2.89543 16.5 4 16.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22 18.08C0.48 18.4 0 19.12 0 19.93V20.5C0 21.05 0.45 21.5 1 21.5H4.5V19.89C4.5 19.06 4.73 18.28 5.13 17.6C4.76 17.54 4.39 17.5 4 17.5C3.01 17.5 2.07 17.71 1.22 18.08Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.5C21.1046 16.5 22 15.6046 22 14.5C22 13.3954 21.1046 12.5 20 12.5C18.8954 12.5 18 13.3954 18 14.5C18 15.6046 18.8954 16.5 20 16.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.78 18.08C21.93 17.71 20.99 17.5 20 17.5C19.61 17.5 19.24 17.54 18.87 17.6C19.27 18.28 19.5 19.06 19.5 19.89V21.5H23C23.55 21.5 24 21.05 24 20.5V19.93C24 19.12 23.52 18.4 22.78 18.08Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.24 17.15C15.07 16.63 13.63 16.25 12 16.25C10.37 16.25 8.93 16.64 7.76 17.15C6.68 17.63 6 18.71 6 19.89V20.5C6 21.05 6.45 21.5 7 21.5H17C17.55 21.5 18 21.05 18 20.5V19.89C18 18.71 17.32 17.63 16.24 17.15Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5C9 14.16 10.34 15.5 12 15.5C13.66 15.5 15 14.16 15 12.5C15 10.84 13.66 9.5 12 9.5C10.34 9.5 9 10.84 9 12.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48 11.36C2.17 10.6 2 9.86 2 9.1C2 6.52 4.02 4.5 6.6 4.5C9.28 4.5 10.42 6.24 12 8.09C13.57 6.26 14.7 4.5 17.4 4.5C19.98 4.5 22 6.52 22 9.1C22 9.86 21.83 10.6 21.52 11.36C22.17 11.67 22.7 12.18 23.05 12.8C23.65 11.6 24 10.38 24 9.1C24 5.4 21.1 2.5 17.4 2.5C15.31 2.5 13.31 3.47 12 5.01C10.69 3.47 8.69 2.5 6.6 2.5C2.9 2.5 0 5.4 0 9.1C0 10.38 0.35 11.6 0.96 12.8C1.31 12.18 1.84 11.67 2.48 11.36Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiversityIcon);
export default __webpack_public_path__ + "static/media/DiversityIcon.a3a3a4ae8891a6ef67c9dd5e8a162177.svg";
export { ForwardRef as ReactComponent };